import { ref } from 'vue'

export const useCrossSectional = () => {
  const selectFlagIndicators = ref([
    '有',
    '無',
  ])
  return {
    selectFlagIndicators
  }
}
